import { useState } from 'react';
import { Check, FloppyDisk } from '@phosphor-icons/react';
import PageHeader from '../../../shared/components/PageHeader';
import { LANGUAGE_NAMES } from '../../../shared/constants/languages';

type LanguagePageProps = {
  language: string;
  onSave: (language: string) => void;
  back: () => void;
  t: any;
};

const languages = [['cs', 'CZ'], ['en', 'EN'], ['vi', 'VI']];

export default function LanguagePage({ language, onSave, back, t }: LanguagePageProps) {
  const [value, setValue] = useState(language);

  return (
    <PageHeader back={back} eyebrow={t.appLanguage} title={t.language} subtitle={t.languageSubtitle}>
      <section className="language-card" role="radiogroup" aria-label={t.language}>
        {languages.map(([id, code]) => (
          <button
            type="button"
            className={value === id ? 'selected' : ''}
            onClick={() => setValue(id)}
            role="radio"
            aria-checked={value === id}
            key={id}
          >
            <span className="lang-code">{code}</span>
            <span>
              <b>{LANGUAGE_NAMES[id]}</b>
              <small>{value === id ? t.selectedLanguage : t.selectLanguage}</small>
            </span>
            <span className="language-choice" aria-hidden="true">
              {value === id && <Check weight="bold" />}
            </span>
          </button>
        ))}
        <button
          type="button"
          className="primary full"
          disabled={value === language}
          onClick={() => onSave(value)}
        >
          <FloppyDisk />{t.save}
        </button>
      </section>
    </PageHeader>
  );
}
